<script lang="ts">
  import { i18n } from '../i18n/index.svelte';
  import PixelIcon, { type PixelIconName } from './PixelIcon.svelte';

  interface Props {
    icon?: PixelIconName;
    title: string;
    description: string;
    /** Drives the tag's colour and wording; omitted for a secret still hidden. */
    rarity?: 'comun' | 'raro' | 'epico' | 'legendario';
    unlocked?: boolean;
    progress?: number;
  }

  let {
    icon = 'lock',
    title,
    description,
    rarity,
    unlocked = false,
    progress = 0,
  }: Props = $props();

  const t = $derived(i18n.t);
  const RARITY_LABEL = $derived({
    comun: t.achievements.rarity.comun,
    raro: t.achievements.rarity.raro,
    epico: t.achievements.rarity.epico,
    legendario: t.achievements.rarity.legendario,
  });
  const filled = $derived(Math.round(Math.min(100, Math.max(0, progress)) / 10));
</script>

<article class="ach {unlocked ? 'ach--unlocked' : ''}" data-rarity={rarity}>
  <span class="abox"><PixelIcon name={unlocked ? icon : 'lock'} size={54} /></span>
  <span class="ach__copy">
    <span class="ach__head">
      <strong class="ach__title">{title}</strong>
      {#if rarity}<span class="ach__rarity">{RARITY_LABEL[rarity]}</span>{/if}
    </span>
    <span class="tiny">{description}</span>
    <span
      class="prog"
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin="0"
      aria-valuemax="100"
    >
      {#each { length: 10 } as _, index (index)}<i class:f={index < filled}></i>{/each}
    </span>
  </span>
</article>
